import { createModalContext, useModalState } from '@/common/app/modal'
import { ChildProps } from '@/common/util/props'

import AutoScheduleModal from '@/components/container/modal/automationReview/AutoScheduleModal'

interface AutoScheduleModalState {
  siteId: number
  onApplied?: () => void
}

const defaultValue: AutoScheduleModalState = { siteId: 0 }

export const AutoScheduleModalContext = createModalContext<AutoScheduleModalState>(defaultValue)

const AutoScheduleModalProvider = ({ children }: ChildProps) => {
  const state = useModalState<AutoScheduleModalState>(defaultValue)
  return (
    <AutoScheduleModalContext.Provider value={state}>
      {children}
      <AutoScheduleModal />
    </AutoScheduleModalContext.Provider>
  )
}

export default AutoScheduleModalProvider
